import { render, staticRenderFns } from "./CampaignsFilters.vue?vue&type=template&id=2172b2c5&scoped=true"
import script from "./CampaignsFilters.vue?vue&type=script&lang=js"
export * from "./CampaignsFilters.vue?vue&type=script&lang=js"
import style0 from "./CampaignsFilters.vue?vue&type=style&index=0&id=2172b2c5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2172b2c5",
  null
  
)

export default component.exports